import React, { useState } from "react";
import {
  Button,
  Label,
  Segment,
  Icon,
  Header,
  Grid,
  Divider,
  Message,
  Container,
  Accordion,
} from "semantic-ui-react";
import { ErrorMessage, Field as Fieldmik } from "formik";
import moment from "moment";
import PdfAxios from "../../axiosComponent/downloadpdf";
import Axios from "axios";
import cogoToast from "cogo-toast";
import SingleProduct from "./SingleProduct";
import SingleInvoice from "./SingleInvoice";
import { MyInput } from "../../formikInput/input";
import { values } from "lodash";

const SingleDelivery = ({
  delivery,
  deliveryIndex,
  handleSubmit,
  orderDetail,
  t,
  orderEditMode,
  setOrderEditMode,
  activeOrder,
  serviceType,
  orderTruckLoadType,
}) => {
  const customerNo = localStorage.getItem("customerNumber");
  const [pdfLoading, setPdfLoading] = useState(false);
  const [containerNoDisables, setContainerNoDisables] = useState(true);
  const [defaultContainerNoVal, setDefaultContainerNoVal] = useState();

  const [containerEdit, setContainerEdit] = useState(delivery?.container_no != null ||
    delivery?.container_no != undefined ? false : true);
  const downloadDaughterInvoice = (container, deliveryid, documentid) => {
    PdfAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/deliveries/${deliveryid}/container/${container}/documents/${documentid}`,
    })
      .then((res) => {
        console.log("PDF Failure", res);
        if (res.data.status == 1) {
          cogoToast.success("File Downloaded Successfully");
        } else {
          cogoToast.success(res.data.message);
        }
      })
      .catch((err) => {
        cogoToast.error(err.response.message);
      });
  };

  const handlePdf = (lrNo) => {
    setPdfLoading(true);
    let token = localStorage.getItem("isloggedIn");
    let customerNo = localStorage.getItem("customerNumber");
    let userId = localStorage.getItem("userId");
    let roleName = localStorage.getItem("role");
    let data = {
      lrNo: lrNo,
      customerNumber: +customerNo,
      userId: userId,
      customer_no: +customerNo,
      user_id: +userId,
      customerNo: +customerNo,
      roleName: roleName,
    };
    Axios.post(`${process.env.REACT_APP_BASE_COMMON}/lr/generatePdf`, data, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: token,
      },
    })
      .then((response) => {
        let url = response.data;
        console.log("testing", response);
        window.open(url, "_blank");
        setPdfLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setPdfLoading(false);
      });
  };

  const getDiff = (actual_date, predicted_date) => {
    console.log(
      "getDiffgetDiffgetDiffgetDiffgetDiffgetDiffgetDiffgetDiffgetDiff"
    );
    console.log(actual_date);
    console.log(predicted_date);

    if (actual_date == null || predicted_date == null) {
      return "NA";
    } else {
      let diff = Math.abs(new Date(actual_date) - new Date(predicted_date));
      let diff2 = Math.floor(diff / 60000);
      let tim = diff2;
      let seconds = +tim * 60;
      let d = Math.floor(seconds / (3600 * 24));
      let h = Math.floor((seconds % (3600 * 24)) / 3600);
      let m = Math.floor((seconds % 3600) / 60);
      let dDisplay = d > 0 ? d + (d == 1 ? " day " : " days ") : "";
      let hDisplay = h > 0 ? h + (h == 1 ? " hr " : " hrs ") : "";
      let mDisplay = m > 0 ? m + (m == 1 ? " min " : " mins ") : "";
      return dDisplay + hDisplay + mDisplay;
    }
  };

  const handleDeliverySave = (event, index, deliveryObj) => {
    event.preventDefault();
    event.stopPropagation();
    handleSubmit();
  };

  const deliveryEdit = () => {
    if (orderEditMode === false) {
      setDefaultContainerNoVal(delivery.container_no)
      if (delivery.container_no) {
        setContainerNoDisables(true)
      } else {
        setContainerNoDisables(false)
      }
    } else {
      delivery.container_no = defaultContainerNoVal;
      setContainerNoDisables(true)
    }
    setOrderEditMode(!orderEditMode)
  }

  return (
    <React.Fragment>
      <Label as="a" color="red" ribbon>
        {t("delivery_number") || "Delivery Number"} :{" "}
        {delivery ? delivery.delivery_reference_no : "NA"}
      </Label>

      {activeOrder ? (
        ""
      ) : (
        <>
          <Button
            color="green"
            type="button"
            onClick={() => deliveryEdit()}
            basic
            size="mini"
            circular
            floated="right"
            icon={orderEditMode ? "times" : "edit"}
          />

          {orderEditMode ? (
            <Button
              color="blue"
              type="submit"
              basic
              onClick={(e) => {
                handleDeliverySave(e, deliveryIndex, delivery);
                setContainerNoDisables(true)
              }}
              size="mini"
              icon="save"
              circular
              floated="right"
            />
          ) : (
            ""
          )}
        </>
      )}

      <div className="pad w3-white small">
        <Grid columns={4}>
          <Grid.Column width="3">
            <Header
              className="p-bold-600 labelName"
              size="tiny"
              as="label"
              color="grey"
            >
              {t("customer_lr_no") || "Customer LR Number"}
            </Header>
          </Grid.Column>
          <Grid.Column width="4">
            {delivery?.lr_no ? (
              <Button
                onClick={() => handlePdf(delivery.lr_no)}
                size="mini"
                basic
                icon="file pdf"
                color="red"
                label={{
                  as: "a",
                  basic: true,
                  pointing: "left",
                  content: delivery.lr_no,
                }}
                className="ml-2"
                loading={pdfLoading}
              />
            ) : (
              "NA"
            )}
          </Grid.Column>
          <Grid.Column width="3">
            <Header
              className="p-bold-600 labelName"
              size="tiny"
              as="label"
              color="grey"
            >
              {t("vendor_lr_no") || "Vendor LR Number"}
            </Header>
          </Grid.Column>
          <Grid.Column width="4">
            <Fieldmik
              name={`deliveries[${deliveryIndex}].transporter_lr_no`}
              component={MyInput}
              placeholder="Vendor LR Number"
              disabled={orderEditMode ? false : true}
              value={delivery.transporter_lr_no}
            />
            <ErrorMessage
              name={`deliveries[${deliveryIndex}].transporter_lr_no`}
            >
              {(error) => (
                <strong className="w3-text-red w3-tiny font-weight-bold">
                  {error}
                </strong>
              )}
            </ErrorMessage>
          </Grid.Column>
          <Grid.Column width="3">
            <Header
              className="p-bold-600 labelName"
              size="tiny"
              as="label"
              color="grey"
            >
              {t("charge_weight") || "Charged Weight"}
            </Header>
          </Grid.Column>
          <Grid.Column width="4">
            <Fieldmik
              name={`deliveries[${deliveryIndex}].charged_weight`}
              component={MyInput}
              placeholder="Charged Weight"
              value={delivery.charged_weight}
              disabled={orderEditMode ? false : true}
            />
            <ErrorMessage name={`deliveries[${deliveryIndex}].charged_weight`}>
              {(error) => (
                <strong className="w3-text-red w3-tiny font-weight-bold">
                  {error}
                </strong>
              )}
            </ErrorMessage>
          </Grid.Column>
          <Grid.Column width="3">
            <Header
              className="p-bold-600 labelName"
              size="tiny"
              as="label"
              color="grey"
            >
              {"Total Ordered Quantity"}
              <br />
              {"(No of Boxes)"}
            </Header>
          </Grid.Column>
          <Grid.Column width="4">
            <Fieldmik
              name={`deliveries[${deliveryIndex}].total_quantity`}
              component={MyInput}
              placeholder="Total Ordered Quantity"
              value={delivery.total_quantity}
              disabled={orderEditMode ? false : true}
            />
            <ErrorMessage name={`deliveries[${deliveryIndex}].total_quantity`}>
              {(error) => (
                <strong className="w3-text-red w3-tiny font-weight-bold">
                  {error}
                </strong>
              )}
            </ErrorMessage>
          </Grid.Column>

          {(orderDetail?.movement_type &&
            (orderDetail.movement_type == "Import" ||
              orderDetail.movement_type == "Importar")) ||
            (orderDetail?.shipment &&
              (orderDetail.shipment.movement_type == "Import" ||
                orderDetail.shipment.movement_type == "Importar")) ? (
            <React.Fragment>
              {/*==========>Import<============*/}
              <Grid.Column width="3">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="grey"
                >
                  {t("delivery_location") || "Delivery Location"}
                </Header>
              </Grid.Column>
              <Grid.Column width="4">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="black"
                >
                  {delivery?.consignee?.consignee_address || "NA"}
                </Header>
              </Grid.Column>

              <Grid.Column width="3">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="grey"
                >
                  {t("portterminal") || "Port Terminal"}
                </Header>
              </Grid.Column>
              <Grid.Column width="4">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="black"
                >
                  {delivery?.consignor?.consignor_address || "NA"}
                </Header>
              </Grid.Column>

              <Grid.Column width="3">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="grey"
                >
                  {t("yard") || "Yard"}
                </Header>
              </Grid.Column>
              <Grid.Column width="4">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="black"
                >
                  {delivery?.yard_name || "NA"}
                </Header>
              </Grid.Column>

              <Grid.Column width="3">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="grey"
                >
                  {t("drop_location") || "Drop Location"}
                </Header>
              </Grid.Column>
              <Grid.Column width="4">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="black"
                >
                  {delivery?.drop_location || "NA"}
                </Header>
              </Grid.Column>

              {delivery?.container_return_date &&
                delivery?.actual_container_return_date ? (
                <>
                  <Grid.Column width="3">
                    <Header
                      className="p-bold-600 labelName"
                      size="tiny"
                      as="label"
                      color="grey"
                    >
                      {t("difference_drop_date") || "Drop Date Difference"}
                    </Header>
                  </Grid.Column>
                  <Grid.Column width="4">
                    <Header
                      className="p-bold-600 labelName"
                      size="tiny"
                      as="label"
                      color="red"
                    >
                      {getDiff(
                        delivery.actual_container_return_date,
                        delivery.container_return_date
                      )}
                    </Header>
                  </Grid.Column>
                </>
              ) : null}

              <Grid.Column width="3">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="grey"
                >
                  {t("import_decleration_number") || "Import Declaration No."}
                </Header>
              </Grid.Column>
              <Grid.Column width="4">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="black"
                >
                  {delivery?.import_declaration_no || "NA"}
                </Header>
              </Grid.Column>

              <Grid.Column width="3">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="grey"
                >
                  {t("boarding_no") || "Boarding No."}
                </Header>
              </Grid.Column>
              <Grid.Column width="4">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="black"
                >
                  {delivery?.boarding_no || "NA"}
                </Header>
              </Grid.Column>

              <Grid.Column width="3">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="grey"
                >
                  {t("storage_expiration") || "Storage Expiration"}
                </Header>
              </Grid.Column>
              <Grid.Column width="4">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="black"
                >
                  {delivery.storage_expiration_date
                    ? moment
                      .parseZone(delivery.storage_expiration_date)
                      .format("DD-MM-YYYY")
                    : "NA"}
                </Header>
              </Grid.Column>

              <Grid.Column width="3">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="grey"
                >
                  {customerNo == 1327
                    ? t("do_no_expiration") || "DO No. Expiration"
                    : t("demurrage_expiration") || "Demurrage Expiration"}
                </Header>
              </Grid.Column>
              <Grid.Column width="4">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="black"
                >
                  {delivery.demurrage_expiration_date
                    ? moment
                      .parseZone(delivery.demurrage_expiration_date)
                      .format("DD-MM-YYYY")
                    : "NA"}
                </Header>
              </Grid.Column>

              <Grid.Column width="3">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="grey"
                >
                  {t("cha") || "CHA"}
                </Header>
              </Grid.Column>
              <Grid.Column width="4">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="black"
                >
                  {delivery.cha_name || "NA"}
                </Header>
              </Grid.Column>

              <Grid.Column width="3">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="grey"
                >
                  {t("shiping_line") || "Shipping Line"}
                </Header>
              </Grid.Column>
              <Grid.Column width="4">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="black"
                >
                  {delivery.shipping_line_name || "NA"}
                </Header>
              </Grid.Column>

              <Grid.Column width="3">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="grey"
                >
                  {t("container_type") || "Container Type"}
                </Header>
              </Grid.Column>
              <Grid.Column width="4">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="black"
                >
                  {delivery.container_type || "NA"}
                </Header>
              </Grid.Column>

              <Grid.Column width="3">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="grey"
                >
                  {t("container_size") || "Container Size"}
                </Header>
              </Grid.Column>
              <Grid.Column width="4">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="black"
                >
                  {delivery.container_size === "FT40"
                    ? "40 Feet"
                    : delivery.container_size === "FT20"
                      ? "20 Feet"
                      : "NA"}
                </Header>
              </Grid.Column>

              <Grid.Column width="3">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="grey"
                >
                  {t("container_number") || "Container Number"}
                </Header>
              </Grid.Column>
              <Grid.Column width="4">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="black"
                >
                  <Fieldmik
                    name={`deliveries[${deliveryIndex}].container_no`}
                    component={MyInput}
                    placeholder="Container Number"
                    value={delivery.container_no}
                    disabled={containerNoDisables}
                  />
                </Header>
              </Grid.Column>

              <Grid.Column width="3">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="grey"
                >
                  {t("container_seal_no") || "Container Seal No"}
                </Header>
              </Grid.Column>
              <Grid.Column width="4">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="black"
                >
                  {delivery.container_seal_no || "NA"}
                </Header>
              </Grid.Column>

              <Grid.Column width="3">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="grey"
                >
                  {t("ata") || "ETA"}
                </Header>
              </Grid.Column>
              <Grid.Column width="4">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="black"
                >
                  {customerNo == 1122 && delivery.ata_date
                    ? moment
                      .parseZone(delivery.ata_date)
                      .format("DD-MM-YYYY HH:mm")
                    : "NA"}
                </Header>
              </Grid.Column>
            </React.Fragment>
          ) : (orderDetail?.movement_type &&
            (orderDetail.movement_type == "Export" ||
              orderDetail.movement_type == "Exportar")) ||
            (orderDetail?.shipment &&
              (orderDetail.shipment.movement_type == "Export" ||
                orderDetail.shipment.movement_type == "Exportar")) ? (
            <React.Fragment>
              {/*==========>Export<============*/}
              <Grid.Column width="3">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="grey"
                >
                  {t("Yard") || "Yard"}
                </Header>
              </Grid.Column>
              <Grid.Column width="4">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="black"
                >
                  {delivery.yard_name || "NA"}
                </Header>
              </Grid.Column>

              <Grid.Column width="3">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="grey"
                >
                  {t("Stuffing Location") || "Stuffing Location"}
                </Header>
              </Grid.Column>
              <Grid.Column width="4">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="black"
                >
                  {delivery?.consignor?.consignor_address || "NA"}
                </Header>
              </Grid.Column>

              <Grid.Column width="3">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="grey"
                >
                  {t("portterminal") || "Port Terminal"}
                </Header>
              </Grid.Column>
              <Grid.Column width="4">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="black"
                >
                  {delivery?.consignee?.consignee_address || "NA"}
                </Header>
              </Grid.Column>

              <Grid.Column width="3">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="grey"
                >
                  {t("storage_expiration") || "Storage Expiration"}
                </Header>
              </Grid.Column>
              <Grid.Column width="4">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="black"
                >
                  {delivery.storage_expiration
                    ? moment
                      .parseZone(delivery.storage_expiration)
                      .format("DD-MM-YYYY")
                    : "NA"}
                </Header>
              </Grid.Column>

              <Grid.Column width="3">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="grey"
                >
                  {t("DO No.") || "DO No"}
                </Header>
              </Grid.Column>
              <Grid.Column width="4">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="black"
                >
                  {delivery.do_no || "NA"}
                </Header>
              </Grid.Column>

              <Grid.Column width="3">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="grey"
                >
                  {t("DO File") || "DO File"}
                </Header>
              </Grid.Column>
              <Grid.Column width="4">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="black"
                >
                  {delivery.do_file || "NA"}
                </Header>
              </Grid.Column>

              <Grid.Column width="3">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="grey"
                >
                  {t("DO Validity") || "DO Validity"}
                </Header>
              </Grid.Column>
              <Grid.Column width="4">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="black"
                >
                  {delivery.do_validity_date
                    ? moment
                      .parseZone(delivery.do_validity_date)
                      .format("DD-MM-YYYY")
                    : "NA"}
                </Header>
              </Grid.Column>

              <Grid.Column width="3">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="grey"
                >
                  {t("container_type") || "Container Type"}
                </Header>
              </Grid.Column>
              <Grid.Column width="4">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="black"
                >
                  {delivery.container_type || "NA"}
                </Header>
              </Grid.Column>

              <Grid.Column width="3">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="grey"
                >
                  {t("container_size") || "Container Size"}
                </Header>
              </Grid.Column>
              <Grid.Column width="4">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="black"
                >
                  {delivery.container_size === "FT40"
                    ? "40 Feet"
                    : delivery.container_size === "FT20"
                      ? "20 Feet"
                      : "NA"}
                </Header>
              </Grid.Column>

              <Grid.Column width="3">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="grey"
                >
                  {customerNo == 1327
                    ? t("do_no_expiration") || "DO No. Expiration"
                    : t("demurrage_expiration") || "Demurrage Expiration"}
                </Header>
              </Grid.Column>
              <Grid.Column width="4">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="black"
                >
                  {delivery.demurrage_expiration_date
                    ? moment
                      .parseZone(delivery.demurrage_expiration_date)
                      .format("DD-MM-YYYY")
                    : "NA"}
                </Header>
              </Grid.Column>

              <Grid.Column width="3">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="grey"
                >
                  {t("ata") || "ETA"}
                </Header>
              </Grid.Column>
              <Grid.Column width="4">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="black"
                >
                  {delivery.ata_date
                    ? moment
                      .parseZone(delivery.ata_date)
                      .format("DD-MM-YYYY HH:mm")
                    : "NA"}
                </Header>
              </Grid.Column>

              <Grid.Column width="3">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="grey"
                >
                  {t("container_number") || "Container Number"}
                </Header>
              </Grid.Column>
              <Grid.Column width="4">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="black"
                >
                  {delivery?.container_no ? (
                    delivery.container_no
                  ) : (
                    <Fieldmik
                      name={`deliveries[${deliveryIndex}].container_no`}
                      component={MyInput}
                      placeholder="Container Number"
                      disabled={orderEditMode ? false : true}
                      value={delivery.container_no}
                    />
                  )}
                </Header>
              </Grid.Column>

              <Grid.Column width="3">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="grey"
                >
                  {t("Container Seal No") || "Container Seal Number"}
                </Header>
              </Grid.Column>
              <Grid.Column width="4">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="black"
                >
                  {delivery.container_seal_no || "NA"}
                </Header>
              </Grid.Column>
            </React.Fragment>
          ) : (
            <React.Fragment>
              {/*==========>Primary<============*/}
              <Grid.Column width="3">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="grey"
                >
                  {t("consignor_city") || "Consignor City"}
                </Header>
              </Grid.Column>
              <Grid.Column width="4">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="black"
                >
                  {delivery?.consignor?.consignor_city || "NA"}
                </Header>
              </Grid.Column>

              <Grid.Column width="3">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="grey"
                >
                  {t("consignee_city") || "Consignee City"}
                </Header>
              </Grid.Column>
              <Grid.Column width="4">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="black"
                >
                  {delivery?.consignee?.consignee_city || "NA"}
                </Header>
              </Grid.Column>

              <Grid.Column width="3">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="grey"
                >
                  {t("pickuplocation") || "Pickup Location"}
                </Header>
              </Grid.Column>
              <Grid.Column width="4">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="black"
                >
                  {delivery?.consignor?.consignor_address || "NA"}
                </Header>
              </Grid.Column>

              <Grid.Column width="3">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="grey"
                >
                  {t("deliveryLocation") || "Delivery Location"}
                </Header>
              </Grid.Column>
              <Grid.Column width="4">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="black"
                >
                  {delivery?.consignee?.consignee_address || "NA"}
                </Header>
              </Grid.Column>
            </React.Fragment>
          )}

          {delivery.actual_pickup_date ? (
            <></>
          ) : (
            <>
              <Grid.Column width="3">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="grey"
                >
                  {customerNo == 1327 &&
                    ((orderDetail?.movement_type &&
                      (orderDetail.movement_type == "Import" ||
                        orderDetail.movement_type == "Export")) ||
                      (orderDetail?.shipment?.movement_type &&
                        (orderDetail.shipment.movement_type === "Import" ||
                          orderDetail.shipment.movement_type === "Export")))
                    ? t("scheduled_requested_stuffing") ||
                    "Scheduled requested stuffing Date & Time"
                    : t("pickup_date") || "Pickup Date"}
                </Header>
              </Grid.Column>
              <Grid.Column width="4">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="black"
                >
                  {delivery.container_pickup_date
                    ? moment
                      .parseZone(delivery.container_pickup_date)
                      .format("DD-MM-YYYY HH:mm")
                    : "NA"}
                </Header>
              </Grid.Column>
            </>
          )}
          {delivery.actual_delivery_date ? (
            <></>
          ) : (
            <>
              <Grid.Column width="3">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="grey"
                >
                  {t("delivery_date") || "Delivery Date"}
                </Header>
              </Grid.Column>
              <Grid.Column width="4">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="black"
                >
                  {delivery.delivery_date
                    ? moment
                      .parseZone(delivery.delivery_date)
                      .format("DD-MM-YYYY HH:mm")
                    : "NA"}
                </Header>
              </Grid.Column>
            </>
          )}

          {/*=========Temperatur Range========= */}
          {delivery.max_temp ? (
            <React.Fragment>
              <Grid.Column width="3">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="grey"
                >
                  {t("temp_min") || "Temperature Minimum"}
                </Header>
              </Grid.Column>
              <Grid.Column width="4">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="black"
                >
                  {delivery.min_temp
                    ? delivery.min_temp + "\u00b0" + "C"
                    : "NA"}
                </Header>
              </Grid.Column>

              <Grid.Column width="3">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="grey"
                >
                  {t("temp_max") || "Temperature Maximum"}
                </Header>
              </Grid.Column>
              <Grid.Column width="4">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="black"
                >
                  {delivery.max_temp
                    ? delivery.max_temp + "\u00b0" + "C"
                    : "NA"}
                </Header>
              </Grid.Column>
            </React.Fragment>
          ) : (
            ""
          )}

          {/*=========Remarks & Daughter Invoice=========*/}

          <Grid.Column width="3">
            <Header
              className="p-bold-600 labelName"
              size="tiny"
              as="label"
              color="grey"
            >
              {localStorage.getItem("customerNumber") == 1166
                ? "STO/SO/RGP-NRGP/LineItems"
                : t("remarks") || "Remarks"}
            </Header>
          </Grid.Column>
          <Grid.Column width="4">
            <Header
              className="p-bold-600 labelName"
              size="tiny"
              as="label"
              color="black"
            >
              {delivery.remarks || "NA"}
            </Header>
          </Grid.Column>

          {delivery.daughter_invoice ? (
            <React.Fragment>
              <Grid.Column width="3">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="grey"
                >
                  {t("daughter_invoice") || "Daughter Invoice"}
                </Header>
              </Grid.Column>
              <Grid.Column width="4">
                <Button
                  size="mini"
                  basic
                  type="button"
                  onClick={() =>
                    downloadDaughterInvoice(
                      delivery.container_no,
                      delivery.daughter_invoice.delivery_id,
                      delivery.daughter_invoice.document_id
                    )
                  }
                  color="primary"
                  icon
                >
                  <Icon name="download" />
                </Button>
                <Label basic pointing="left">
                  {delivery.daughter_invoice.document_name}
                </Label>
              </Grid.Column>
            </React.Fragment>
          ) : (
            <Grid.Column width="8" />
          )}
        </Grid>

        <Grid columns={6}>
          {delivery.actual_pickup_date ? (
            <>
              <Grid.Column width="2">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="grey"
                >
                  {customerNo == 1327 &&
                    ((orderDetail?.movement_type &&
                      (orderDetail.movement_type == "Import" ||
                        orderDetail.movement_type == "Export")) ||
                      (orderDetail?.shipment?.movement_type &&
                        (orderDetail.shipment.movement_type === "Import" ||
                          orderDetail.shipment.movement_type === "Export")))
                    ? t("scheduled_requested_stuffing") ||
                    "Scheduled requested stuffing Date & Time"
                    : t("pickup_date") || "Pickup Date"}
                </Header>
              </Grid.Column>
              <Grid.Column width="3">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="black"
                >
                  {delivery.container_pickup_date
                    ? moment
                      .parseZone(delivery.container_pickup_date)
                      .format("DD-MM-YYYY HH:mm")
                    : "NA"}
                </Header>
              </Grid.Column>
              <Grid.Column width="2">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="grey"
                >
                  {customerNo == 1327 &&
                    ((orderDetail?.movement_type &&
                      (orderDetail.movement_type == "Import" ||
                        orderDetail.movement_type == "Export")) ||
                      (orderDetail?.shipment?.movement_type &&
                        (orderDetail.shipment.movement_type === "Import" ||
                          orderDetail.shipment.movement_type === "Export")))
                    ? t("actual_requested_stuffing") ||
                    "Actual requested stuffing Date & Time"
                    : t("actual_pick") || "Actual Pickup Date"}
                </Header>
                {/*  */}
              </Grid.Column>
              <Grid.Column width="3">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="black"
                >
                  {delivery.actual_pickup_date
                    ? moment
                      .parseZone(delivery.actual_pickup_date)
                      .format("DD-MM-YYYY HH:mm")
                    : "NA"}
                </Header>
              </Grid.Column>
              <Grid.Column width="2">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="grey"
                >
                  {t("Difference") || "Difference"}
                </Header>
              </Grid.Column>
              <Grid.Column width="3">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="red"
                >
                  {getDiff(
                    delivery.actual_pickup_date,
                    delivery.container_pickup_date
                  )}
                </Header>
              </Grid.Column>
            </>
          ) : (
            ""
          )}
        </Grid>

        <Grid columns={6} className="mb-4">
          {delivery.actual_delivery_date ? (
            <>
              <Grid.Column width="2">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="grey"
                >
                  {t("delivery_date") || "Delivery Date"}
                </Header>
              </Grid.Column>
              <Grid.Column width="3">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="black"
                >
                  {delivery.delivery_date
                    ? moment
                      .parseZone(delivery.delivery_date)
                      .format("DD-MM-YYYY HH:mm")
                    : "NA"}
                </Header>
              </Grid.Column>

              <Grid.Column width="2">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="grey"
                >
                  {t("actual_delivery") || "Actual Delivery Date"}
                </Header>
              </Grid.Column>
              <Grid.Column width="3">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="black"
                >
                  {delivery.actual_delivery_date
                    ? moment
                      .parseZone(delivery.actual_delivery_date)
                      .format("DD-MM-YYYY HH:mm")
                    : "NA"}
                </Header>
              </Grid.Column>
              <Grid.Column width="2">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="grey"
                >
                  {t("Difference") || "Difference"}
                </Header>
              </Grid.Column>
              <Grid.Column width="3">
                <Header
                  className="p-bold-600 labelName"
                  size="tiny"
                  as="label"
                  color="red"
                >
                  {getDiff(
                    delivery.actual_delivery_date,
                    delivery.delivery_date
                  )}
                </Header>
              </Grid.Column>
            </>
          ) : null}
        </Grid>

        <Container fluid>
          <Segment>
            <Header size="tiny">{`Products`} </Header>
            <Divider></Divider>
            {delivery.products.length === 0 ? (
              <Message size="mini" color="yellow">
                No Product(s) Found
              </Message>
            ) : (
              <SingleProduct
                deliveryIndex={deliveryIndex}
                products={delivery.products}
                orderDetail={orderDetail}
                orderEditMode={orderEditMode}
                serviceType={serviceType}
                t={t}
              />
            )}
          </Segment>

          <Segment>
            <Header size="small">{`Invoices`} </Header>
            <Divider />
            {delivery.invoices.length === 0 ? (
              <Message size="mini" color="yellow">
                No Invoice(s) Found
              </Message>
            ) : (
              <SingleInvoice
                deliveryIndex={deliveryIndex}
                invoices={delivery.invoices}
                orderDetail={orderDetail}
                orderEditMode={orderEditMode}
                t={t}
              />
            )}
          </Segment>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default SingleDelivery;
